import React, { createContext, useContext, useState } from 'react';

// Define the context type
interface MemberContextType {
  printMember: boolean;
  setPrintMember: React.Dispatch<React.SetStateAction<boolean>>;
  printOverview: boolean;
  setPrintOverview: React.Dispatch<React.SetStateAction<boolean>>;
  questionnaire: any;
  setQuestionnaire: React.Dispatch<React.SetStateAction<any>>;
  saveQuestionnaire: any;
  setSaveQuestionnaire: React.Dispatch<React.SetStateAction<any>>;
  patientData: any;
  setPatientData: React.Dispatch<React.SetStateAction<any>>;
  eabSnapshotData: any;
  setEabSnapshotData: React.Dispatch<React.SetStateAction<any>>;
  questionnaireRespnse: any;
  setQuestionnaireRespnse: React.Dispatch<React.SetStateAction<any>>;
  cancelAssessment:boolean;
  setCancelAssessment:React.Dispatch<React.SetStateAction<boolean>>;
  discard:boolean;
  setDiscard:React.Dispatch<React.SetStateAction<boolean>>;
}

const MemberContext = createContext<MemberContextType | undefined>(undefined);

export const MemberProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children
}) => {
  const [printMember, setPrintMember] = useState(false); // State to manage
  const [printOverview, setPrintOverview] = useState(false);
  const [questionnaire, setQuestionnaire] = useState<any>(null);
  const [saveQuestionnaire, setSaveQuestionnaire] = useState<any>(null);
  const [patientData, setPatientData] = useState<any>(null); // State to manage patient details
  const [eabSnapshotData, setEabSnapshotData] = useState<any>(null); // State to manage EAB snapshot
  const [questionnaireRespnse, setQuestionnaireRespnse] = useState<any>(null); // State to manage questionnaire response
  const [cancelAssessment,setCancelAssessment]=useState<boolean>(false);
  const [discard, setDiscard]=useState(false)
  return (
    <MemberContext.Provider
      value={
        {
          printMember,
          setPrintMember,
          printOverview,
          setPrintOverview,
          questionnaire,
          setQuestionnaire,
          saveQuestionnaire,
          setSaveQuestionnaire,
          patientData,
          setPatientData,
          eabSnapshotData,
          setEabSnapshotData,
          questionnaireRespnse,
          setQuestionnaireRespnse,
          cancelAssessment,
          setCancelAssessment,
          discard,
          setDiscard
        } as MemberContextType
      }
    >
      {children}
    </MemberContext.Provider>
  );
};

export const useMemberContext = (): MemberContextType => {
  const context = useContext(MemberContext);
  if (!context) {
    console.log('Context Not working');
    throw new Error('');
  }
  return context;
};
